// @flow

export default class {
  sign: string;
  rightValue: any;
  probability: number;

  constructor(sign: string, rightValue: any, probability: number) {
    this.sign = sign;
    this.rightValue = rightValue;
    this.probability = typeof probability === 'undefined' ? 100 : probability;
  }

  premise(value: any): boolean {
    switch (this.sign) {
      case '<':
        return value < this.rightValue;
      case '<=':
        return value <= this.rightValue;
      case '>':
        return value > this.rightValue;
      case '>=':
        return value >= this.rightValue;
      case '=':
      case '==':
        return value == this.rightValue;
      case '!=':
        return value != this.rightValue;
      default:
        throw 'Undefined sign';
    }
  }

  judge(value: number): boolean {
    return this.premise(value) && Math.random() * 100 < this.probability;
  }

  getString(): string {
    const formula = `x ${this.sign} ${this.rightValue} のとき ${
      this.probability
    }%`;
    return formula;
  }

  getSampleData(start: number, end: number): Array<number> {
    const results = [];
    for (let i = start; i <= end; i++) {
      results.push(this.premise(i) ? this.probability / 100 : 0);
    }
    return results;
  }
}



// WEBPACK FOOTER //
// ./src/lib/condition/basic_condition.js